import styled from 'styled-components'
import { containerExpanded } from '../../lib/styles/Container'

export const StyledTabTeaserWrapper = styled.div`
  ${containerExpanded};
  margin: 0 auto;
`

export const StyledTabTeaserCard = styled.div`
  background-color: var(--c-theme-6);
  border-radius: 1.5rem;
  padding: 2rem 4rem 4rem 4rem;
  transition: background-color 0.25s;

  @media screen and (max-width: 992px) {
    padding: 2rem 3rem 3rem 3rem;
  }

  @media screen and (max-width: 480px) {
    padding: 1.5rem 2rem 2rem 2rem;
  }
`
